// ======================================================================
// File Name       : SelectGroupUserHistoryDialogContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Col, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { MESSAGE_TYPE, MESSAGE_TIME_OUT, MODAL_SIZE } from '../../constants/index';
import TreeView from '../../components/Tree';
import ModalWrapper from '../../components/modal/ModalWrapper';
import * as groupActions from '../../actions/GroupAction';
import * as Functions from '../../constants/FunctionConstants';
import TREE_ICON from '../../images/tree/default-icon.png';
import { canAccess } from '../../utils/AuthedUtils';
import { createTree } from '../../utils/groupUtils';

class SelectGroupUserHistoryDlgContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      data: [],
      groupList: [],
      selectedTargetGroup: {},
      fetchData: false,
    };
    // this.buildTree = this.buildTree.bind(this);
    // this.populateTreeView = this.populateTreeView.bind(this);
    // this.convertJsonToDataTree = this.convertJsonToDataTree.bind(this);
    this.handleSelectNode = this.handleSelectNode.bind(this);
    this.onOK = this.onOK.bind(this);
    this.getModalOptions = this.getModalOptions.bind(this);
  }

  componentWillMount() {
    if (!this.props.allSecernIds || !this.props.bySecernId || this.props.allSecernIds.length <= 0) {
      this.props.dispatch(groupActions.fetchGroupStructure());
    }
  }

  /**
   * Handle event when click on OK of select group dialog
   *
   */
  onOK() {
    const { selectedTargetGroup } = this.state;
    if (Object.keys(selectedTargetGroup) && Object.keys(selectedTargetGroup).length) {
      this.props.dispatch(groupActions.selectedGroupOnDialog(selectedTargetGroup));
    }
    this.props.hideModal();
  }

  /**
   * Handle select node
   *
   * @param {*} event
   * @param {object} node
   */
  handleSelectNode(event, nodes) {
    if (!nodes || !nodes.data) return;
    const selectedTargetGroup = nodes.data;
    this.setState({ selectedTargetGroup });
  }

  getModalOptions() {
    return {
      title: 'ユーザーグループを選択してください',
      footerBtns: [
        { name: 'キャンセル', onClick: this.props.onCancel, variant: 'default' },
        { name: 'OK', onClick: this.onOK, variant: 'primary' },
      ],
    };
  }

  createTree() {
    const { bySecernId, allSecernIds } = this.props;
    const menu = null;
    const buildNodeData = (acc, groupSecernId) => {
      const group = bySecernId[groupSecernId];
      if (!group) return acc;
      const { child = [] } = group;
      const children = child.reduce(buildNodeData, []);
      acc.push({
        id: groupSecernId,
        text: group.groupName,
        icon: false,
        data: { menu, callbackData: group },
        state: {
          selected:
            Object.keys(this.state.selectedTargetGroup).length > 0
              ? this.state.selectedTargetGroup &&
                group.groupName === this.state.selectedTargetGroup.groupName
              : this.props.selectedTargetGroup &&
                group.groupName === this.props.selectedTargetGroup.groupName,
        },
        children,
      });
      return acc;
    };
    return allSecernIds.reduce(buildNodeData, []);
  }

  /**
   * Render GUI
   * @returns {XML}
   */
  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    const { groupList } = this.props;
    let selectedTargetGroup = this.props.selectedTargetGroup;
    if (this.state.selectedTargetGroup
      && Object.keys(this.state.selectedTargetGroup)
      && Object.keys(this.state.selectedTargetGroup).length) {
      selectedTargetGroup = this.state.selectedTargetGroup;
    }
    const nodes = createTree(groupList, false, selectedTargetGroup);
    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.props.hideModal}>
        <Col sm={12}>
          <Form className='form-horizontal'>
            {nodes && nodes.length ? <TreeView
              data={nodes}
              isNotRefresh
              ref={(instance) => {
                this.treeInstance = instance;
              }}
              onSelectNode={this.handleSelectNode}
            /> : null}
          </Form>
        </Col>
      </ModalWrapper>
    );
  }
}

SelectGroupUserHistoryDlgContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  bySecernId: PropTypes.shape().isRequired,
  allSecernIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { structures, groupList } = state.group;
  const { selectedTargetGroup } = state.group;
  return { ...structures, selectedTargetGroup, groupList };
};

export default connect(mapStateToProps)(SelectGroupUserHistoryDlgContainer);
